import "@/App.css";
import { useEffect, useState } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { FormContextProvider } from "@/components/context/useFormContext";
import { LOAN_TYPE } from "@/lib/constants";
import { QuickFormMain } from "@/components/forms/quickForm/quickFormMain";
import FormSkeleton from "@/components/ui/formSkeleton";
import usePageLoading from "@/lib/usePageLoading";

const queryClient = new QueryClient();

type AppProps = {
	rootElement: HTMLElement;
};

export default function App({ rootElement }: AppProps) {
	const pageLoading = usePageLoading();
	const [component, setComponent] = useState<string | undefined>(undefined);
	const [siteTitle, setSiteTitle] = useState<string | undefined>(undefined);

	useEffect(() => {
		const container = rootElement?.dataset.component;
		const siteTitle = rootElement?.dataset.title;

		setSiteTitle(siteTitle);
		setComponent(container);
	}, [rootElement]);

	const renderComponent = () => {
		return pageLoading && component === "BiiGGA" ? (
			<FormSkeleton />
		) : (
			<QuickFormMain
				rootId={rootElement}
				siteTitle={siteTitle}
				lenderName={component}
				loanTypes={LOAN_TYPE}
			/>
		);
	};

	return (
		<FormContextProvider id={rootElement}>
			<QueryClientProvider client={queryClient}>
				{component ? renderComponent() : <div>Loading...</div>}
			</QueryClientProvider>
		</FormContextProvider>
	);
}
